import styled from "styled-components";

export const Page = styled.div`
  height: 100%;
  overflow-y: auto;
  padding: 28px 32px 40px;
  background: #f7f9fc;
  color: #1b2028;
  font-family: "Manrope", sans-serif;
`;

export const Header = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 24px;
  margin-bottom: 20px;
`;

export const Title = styled.h1`
  margin: 0;
  font-size: 26px;
  line-height: 34px;
  font-weight: 700;
`;

export const Subtitle = styled.p`
  margin: 5px 0 0;
  color: #66758a;
  font-size: 14px;
`;

export const SearchPanel = styled.div`
  padding: 18px;
  border: 1px solid #dde2e9;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 3px 12px rgba(18, 38, 63, 0.04);
`;

export const SearchRow = styled.form`
  display: flex;
  gap: 10px;
  align-items: center;
`;

export const Filters = styled.div`
  display: grid;
  grid-template-columns: repeat(5, minmax(150px, 1fr));
  gap: 12px;
  margin-top: 14px;

  @media (max-width: 1100px) {
    grid-template-columns: repeat(2, minmax(180px, 1fr));
  }
`;

export const FilterLabel = styled.label`
  display: flex;
  flex-direction: column;
  gap: 5px;
  color: #536176;
  font-size: 12px;
  font-weight: 600;
`;

export const FilterFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 14px;
`;

export const ResultSummary = styled.div`
  margin: 20px 0 10px;
  color: #536176;
  font-size: 13px;
`;

export const ResultList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const ResultCard = styled.article`
  padding: 17px 18px;
  border: 1px solid #dde2e9;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover,
  &:focus-visible {
    border-color: #8fb1df;
    box-shadow: 0 4px 14px rgba(12, 83, 187, 0.08);
    outline: none;
  }
`;

export const ResultTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
`;

export const ResultTitle = styled.h2`
  margin: 0;
  color: #172033;
  font-size: 16px;
  line-height: 22px;
  font-weight: 700;
`;

export const Meta = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
  margin-top: 6px;
  color: #66758a;
  font-size: 12px;
`;

export const TagRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;
`;

export const Snippet = styled.p`
  margin: 11px 0 0;
  color: #48566b;
  font-size: 13px;
  line-height: 20px;

  mark {
    padding: 0 2px;
    background: #fff1a8;
  }
`;

export const EmptyState = styled.div`
  padding: 56px 20px;
  border: 1px dashed #ccd4df;
  border-radius: 12px;
  background: #fff;
`;

export const PaginationRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
`;

export const DetailLayout = styled.div`
  display: grid;
  grid-template-columns: ${(props) =>
    props.$withPreview ? "minmax(320px, 420px) minmax(0, 1fr)" : "minmax(0, 1fr)"};
  gap: ${(props) => (props.$withPreview ? "20px" : "0")};
  height: ${(props) => (props.$withPreview ? "calc(100vh - 112px)" : "auto")};

  @media (max-width: 900px) {
    grid-template-columns: minmax(0, 1fr);
    height: auto;
  }
`;

export const DetailInfo = styled.div`
  min-width: 0;
  overflow-y: auto;
  padding-right: 4px;
`;

export const InlinePreviewPanel = styled.div`
  min-width: 0;
  height: 100%;
  min-height: 520px;
  overflow: hidden;
  border: 1px solid #d8dee8;
  border-radius: 8px;

  @media (max-width: 900px) {
    height: 70vh;
  }
`;

export const DetailSection = styled.section`
  margin-bottom: 22px;
`;

export const DetailHeading = styled.h3`
  margin: 0 0 8px;
  color: #344054;
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
`;

export const DetailValue = styled.div`
  color: #344054;
  font-size: 14px;
  line-height: 21px;
`;

export const DrawerFooter = styled.div`
  display: flex;
  gap: 10px;
  padding-top: 14px;
  border-top: 1px solid #e5e9f0;
`;

export const PreviewBody = styled.div`
  height: ${(props) => (props.$embedded ? "100%" : "calc(100vh - 170px)")};
  min-height: 420px;
  background: #e7ebf1;
`;

export const PreviewStatus = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  padding: 32px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 12px;
`;

export const Warning = styled.div`
  margin: 12px 0;
  padding: 10px 12px;
  border-radius: 8px;
  background: #fff8e6;
  color: #7a5412;
  font-size: 12px;
  line-height: 18px;
`;

export const MatterResults = styled.div`
  max-height: 180px;
  margin-top: 6px;
  overflow-y: auto;
  border: 1px solid #e1e6ee;
  border-radius: 8px;
`;

export const MatterResult = styled.button`
  width: 100%;
  padding: 9px 11px;
  border: 0;
  border-bottom: 1px solid #edf0f5;
  background: ${(props) => (props.$selected ? "#edf5ff" : "#fff")};
  color: #344054;
  text-align: left;
  cursor: pointer;

  &:last-child {
    border-bottom: 0;
  }

  &:hover {
    background: #edf5ff;
  }
`;
